<template>
  <v-navigation-drawer 
    id="sidebar" 
    app 
    permanent
    stateless
    width="157px"
    v-if="$vuetify.breakpoint.smAndUp"
  >
    <v-row class="pa-0 ma-0">
      <v-col class="logo">
        <v-img
          contain
          width="70"
          height="85"
          :src="require('@/assets/img/gglogo.png')"
        />
      </v-col>
    </v-row>

    <v-col class="d-flex align-center flex-column">
      <scrollactive
        :scrollOnStart="false"
        active-class="active"
        class="my-nav"
      >
        <template v-for="(item, i) in menu">
          <div style="margin: 12px" :key="i">
            <a :href="item.route" class="scrollactive-item">
              <div class="btn d-flex justify-center">
                <v-icon :class="`i ${item.icon}`">{{ item.icon }}</v-icon>
              </div>
            </a>
          </div>
        </template>
      </scrollactive>
    </v-col>

    <v-row>
      <v-col class="d-flex justify-center flex-row">
        <v-btn
          v-for="item in footer"
          :key="item.href"
          icon
          :href="item.href"
          target="_blank"
        >
          <v-icon color="white">{{ item.icon }}</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-navigation-drawer>

  <v-app-bar
    v-else
    flat
    color="transparent"
    class="mt-5"
  >
    <v-img
      contain
      width="100"
      height="60"
      :src="require('@/assets/img/gglogo.png')"
    />

    <v-spacer></v-spacer>

    <v-col class="d-flex justify-center flex-row">
      <v-btn
        v-for="item in footer"
        :key="item.href"
        icon
        :href="item.href"
        target="_blank"
      >
        <v-icon size="30" color="white">{{ item.icon }}</v-icon>
      </v-btn>
    </v-col>
  </v-app-bar>
</template>

<script>
import Vue from "vue";
import VueScrollactive from "vue-scrollactive";
Vue.use(VueScrollactive);

import {
  mdiTelegram,
  mdiTwitter,
  mdiInstagram,
  mdiLightningBolt,
  mdiAccountGroup,
  mdiHandshake,
  mdiHome,
  mdiAccessPoint,
  mdiChevronDoubleRight,
} from "@mdi/js";
export default {
  name: "SideBar",
  data() {
    return {
      drawer: true,
      menu: [
        { title: "1", route: "#overview", icon: mdiHome },
        { title: "2", route: "#features", icon: mdiAccessPoint },
        { title: "3", route: "#fourth", icon: mdiLightningBolt },
        { title: "4", route: "#roadmap", icon: mdiChevronDoubleRight },
        { title: "5", route: "#team", icon: mdiAccountGroup },
        { title: "6", route: "#partners", icon: mdiHandshake },
      ],
      footer: [
        { href: "https://t.me/GoodGameToken", icon: mdiTelegram },
        { href: "https://twitter.com/goodgamefinance", icon: mdiTwitter },
        { href: "https://www.instagram.com/goodgamefinance/", icon: mdiInstagram },
      ],
    };
  },
};
</script>

<style lang="scss">
  @import "../assets/styles/SideBar.scss";
</style>